<template>
    <div class="RiskProfiles">
        <RiskProfileEmptyState v-if="riskProfiles.length === 0" v-bind="$attrs" />
        <div v-else class="RiskProfiles__tableWrapper">
            <RiskProfileTable :risk-profiles="riskProfiles" v-bind="$attrs" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.RiskProfiles {
    display: flex;
    flex-direction: column;

    &__tableWrapper {
        flex: 1;
        min-height: 0;
    }
}
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { RiskProfile } from '@evidentid/tprm-portal-lib/models/decisioning/RiskProfile.model';

    import RiskProfileEmptyState
        from '@/modules/decisioning-criteria/components/RiskProfileEmptyState/RiskProfileEmptyState.vue';
    import RiskProfileTable
        from '@/modules/decisioning-criteria/components/RiskProfileTable/RiskProfileTable.vue';

    @Component({
        components: {
            RiskProfileTable,
            RiskProfileEmptyState,
        },
    })
    export default class RiskProfiles extends Vue {
        @Prop({ type: Array, default: () => [] })
        private riskProfiles!: RiskProfile[];
    }
</script>
